/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {accountGenerator} from '../api'

export const useMutationAccountGenerator = createReactQueryMutationHook('accountGenerator', accountGenerator)
